import React, {memo} from "react";
import ErrorMsg from '../components/ErrorMsg';

export default memo(()=>{
    return <ErrorMsg>沒有此頁面</ErrorMsg>
});
